import React,{useState,useEffect,useContext} from 'react'
import {
    useLocation,
  } from "react-router-dom";
import Payer from './Payer';
import Payment from './Payment';
import Projection from './Projection';
import Pending from './Pending';
import Productivity from './Productivity';
import PaymentsMapping from './PaymentsMapping';
import { UserContext } from '../../App';
import AuthErrorPop from '../Util/AuthErrorPop';

function CollectionMain({email}) {
    const location = useLocation();
    const [url, setUrl] = useState(location.pathname);
    const [value,SetValue]=useState('')
    const pathnameParts = location.pathname.split('/');
    const tabname = pathnameParts[pathnameParts.length - 1];
    const [authPop,setAuthPop]=useState('')
    const {user} = useContext(UserContext);
    const {handleAccess,accessList,apiState,setApiState}= useContext(UserContext);
 
    useEffect(()=>{
        SetValue(tabname)
     },)
  return (
    <div>
            {(value==='payer') &&
              <Payer handleAccess={handleAccess} authPop={authPop} setAuthPop={setAuthPop} />
            }

            {(value==='payment') &&
              <Payment />
            }

            {(value==='projection') &&
                  <Projection />
             }

            {(value==='pending') &&
                          <Pending />
                        }

            {(value==='productivity') &&
                          <Productivity />
                        }
            {/* The menu hides this page without View, but the URL is still reachable.
                Nothing is rendered until permissions have loaded, so a slow fetch
                never flashes a false "no access". */}
            {(value==='paymentmapping') &&
                          (!accessList
                            ? null
                            : handleAccess('PaymentMapping','View')
                              ? <PaymentsMapping email={email} handleAccess={handleAccess} />
                              : <div style={{ padding: '48px', textAlign: 'center', color: '#dc2626', fontSize: '14px' }}>
                                  You do not have access to the Payments page.
                                </div>)
                        }

            <AuthErrorPop authPop={authPop} setAuthPop={setAuthPop}  />
    </div>

    
  )
}

export default CollectionMain
